module.exports = __webpack_public_path__ + "static/img/logo.75911a6e.svg";